
import LotterySectionTitle from "./LotterySectionTitle.vue";

export default {
  name: "LotteryRules",
  components: {
    LotterySectionTitle,
  },
  props: {
    ruleContent: {
      type: String,
      default: "",
    },
    copy: {
      type: Object,
      required: true,
    },
  },
};
